import { render, staticRenderFns } from "./PendingSwap.vue?vue&type=template&id=aff46d9a&scoped=true"
import script from "./PendingSwap.vue?vue&type=script&lang=js"
export * from "./PendingSwap.vue?vue&type=script&lang=js"
import style0 from "./PendingSwap.vue?vue&type=style&index=0&id=aff46d9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff46d9a",
  null
  
)

export default component.exports